import { FaturaDetay } from './../../../models/FaturaDetay';
import { UrunsecPage } from './../urunsec/urunsec';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Ortak } from './../../../providers/ortak';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { BllSiparisDetay } from './../../../providers/bll/bll-siparis-detay';
import { Component, ViewChild } from '@angular/core';
import {  NavController, NavParams, Platform } from 'ionic-angular';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { M_SIPARIS_DETAY } from '../../../models/M_SIPARIS_DETAY';



/**
 * Generated class for the OzetPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-ozet',
  templateUrl: 'ozet.html',
})
export class OzetPage {
  // @ViewChild(Nav) nav: Nav;

  secilenSiparisID: number = -1;
  siparisIdListesi = [];
  CariObj: any = {}
  toplam: number = 0;
  toplamIskonto: number = 0;
  genelToplam: number = 0;
  odenenToplam: number = 0;
  indirimliGenelToplam: number = 0;
  onaylanmamisindirimliGenelToplam: number = 0;
  bolgeID: any;
  birimID: any;
  onaylaPasif: boolean = false;
  aktifSiparisVeDetaylari: any = { SIPARIS_BASLIK: {}, SIPARIS_DETAYLARI: [] };
  siparisBaslikDurumID = 1;
  siparisDetaylari:any = { SIPARIS_BASLIK: {}, SIPARIS_DETAYLARI: [] };
  constructor(public platform:Platform, public navCtrl: NavController,public viewCtrl:ViewController ,public navParams: NavParams, public ortak: Ortak,  public bllOrtak: BllOrtak, public modalCtrl: ModalController, public view: ViewController) {
    this.CariObj = navParams.get("CariObj");
    this.bolgeID = navParams.get("bolgeID");
 


  }

  ionViewDidLoad() {
    this.siparisYukelemeIslemleri();
  }

  siparisYukelemeIslemleri() {

    this.CariObj.siparislerVeDetaylari = this.CariObj.siparislerVeDetaylari.filter(a => a.SIPARIS_BASLIK.SIPARIS_DURUM_ID == 1);
    this.siparisIdListesi = [];
    this.secilenSiparisID = -1;
    if (this.CariObj.siparislerVeDetaylari.length > 1) {
      this.siparisIdListesi.push(-1);
      var tumSiparisDetaylari = [];
      this.CariObj.siparislerVeDetaylari.forEach(element => {
        tumSiparisDetaylari = tumSiparisDetaylari.concat(element.SIPARIS_DETAYLARI);
        this.siparisIdListesi.push(element.SIPARIS_BASLIK.ID);
      });
      var butunSiparisVeDetaylari = { SIPARIS_BASLIK: { ID: -1 }, SIPARIS_DETAYLARI: tumSiparisDetaylari };
      this.CariObj.siparislerVeDetaylari.push(butunSiparisVeDetaylari);
      this.aktifSiparisVeDetaylari = butunSiparisVeDetaylari;

    
    
    }
    else {
      this.aktifSiparisVeDetaylari = this.CariObj.siparislerVeDetaylari[0];
      this.secilenSiparisID = this.aktifSiparisVeDetaylari.SIPARIS_BASLIK.ID;
      this.siparisIdListesi.push(this.secilenSiparisID);
    }
    this.siparisDetayListesi_Temp();
     

    
  }
  siparisDetayListesi_Temp() {
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll({LogicalRef:-1  }).then(a => {
      var sonuc = <any>a;
      this.siparisDetaylari = sonuc;
    })
  }
  fiyatHesapla(onaylanmisSiparisDetaylari, onaylanmamisSiparisDetaylari) {
    this.genelToplam = 0;
    this.toplam = 0;
    this.odenenToplam = 0;
    this.onaylanmamisindirimliGenelToplam = 0;
    onaylanmisSiparisDetaylari.forEach(item => {
      var satirToplamTutar = item.BIRIM_FIYAT * item.MIKTAR;
      var satirrOdenenTutar = item.BIRIM_FIYAT * item.ODENEN_MIKTAR;
      var satirKalanTutar = satirToplamTutar - satirrOdenenTutar;
      this.genelToplam = this.genelToplam + satirKalanTutar;
      this.toplam = this.toplam + satirToplamTutar;
      this.odenenToplam = this.odenenToplam + satirrOdenenTutar;
      this.indirimliGenelToplam = this.genelToplam;
    });
    onaylanmamisSiparisDetaylari.forEach(item => {
      var satirToplamTutar = item.BIRIM_FIYAT * item.MIKTAR;
      var satirrOdenenTutar = item.BIRIM_FIYAT * item.ODENEN_MIKTAR;
      var satirKalanTutar = satirToplamTutar - satirrOdenenTutar;
      this.genelToplam = this.genelToplam + satirKalanTutar;
      this.toplam = this.toplam + satirToplamTutar;
      this.odenenToplam = this.odenenToplam + satirrOdenenTutar;
      this.onaylanmamisindirimliGenelToplam = this.genelToplam - this.indirimliGenelToplam;
    });
  }

  

  MiktarGuncelle(detay) {
    if (detay.SIPARIS_DURUM_ID == 255) {
      this.ortak.alertSiparisMiktarGuncelle(detay).then(a => {
        var sonuc = <any>a;
        var values = sonuc.values;
        if (detay.Miktar != "") {
          if (detay.Miktar>= 1) {
            var siparisDetay = new M_SIPARIS_DETAY();
            if (values.miktar <= 0 || values.miktar == null)
              values.miktar = detay.Miktar;
            siparisDetay.Miktar = values.miktar;
           // siparisDetay.LogicalRef = detay.ID;
            var bllSiparisDetay = new BllSiparisDetay();
            bllSiparisDetay.miktarGuncelle(siparisDetay).then(a => {
              this.siparisDetayListesi_Temp();
            }).catch(x => {
             
            })
          }
          else
            detay.MIKTAR = 1;
        }
      });
    }
  }
  kalemSil(detay) {
    var bllSiparisDetay = new BllSiparisDetay();
    if (detay.SIPARIS_DURUM_ID == 255) {
      bllSiparisDetay.delete({ ID: detay.ID }).then(a => {
        this.siparisDetayListesi_Temp();
      }).then(c => {
     
      })
    }
    
  }
 
  
  
  onayla() {
    this.onaylaPasif = true;
    var siparisID = this.siparisIDGetir();
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll({ SIPARIS_ID: siparisID }).then(a => {
      var formData = new FormData();
      formData.append("siparis_baslik_durum_id", this.siparisBaslikDurumID.toString());
      formData.append("siparis_detaylari_json", JSON.stringify(a));
      this.bllOrtak.islem(formData, "OpSiparisiOnayla", "", false).then(a => {
        bllSiparisDetay.execRawQuery("DELETE FROM M_SIPARIS_DETAY WHERE SIPARIS_ID = " + siparisID).then(b => {
          this.kapat();
          // this.navCtrl.push(SiparisMasaSecPage, { masaObj: this.masaObj, bolgeID: this.bolgeID });
        })
      })
    }).catch(x => {
      this.onaylaPasif = false;
      alert("Hata")
    })
  }
  siparisIDGetir(): number {
    var siparisID: number = -1;
    siparisID = this.CariObj.siparislerVeDetaylari[0].LogicalRef;
    // siparisID = this.aktifSiparisVeDetaylari.SIPARIS_BASLIK.ID;
    return siparisID;
  }
  miktarChange(detay) {
    if (detay.SIPARIS_DURUM_ID == 255) {
      if (detay.miktar != "") {
        if (detay.miktar > 0) {
          var bllSiparisDetay = new BllSiparisDetay();
          bllSiparisDetay.miktarGuncelle(detay).then(a => {
          })
        }
      }
    }
  }

    kapat(){
      this.viewCtrl.dismiss();
    }
  }


// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/ozet/ozet.ts